import { render, staticRenderFns } from "./ResetPasswordContainer.vue?vue&type=template&id=1777d54c&"
import script from "./ResetPasswordContainer.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports